import { store, env } from 'azshared';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import App from './App';
import './index.scss';

// Set CSS variables for asset URLs from env.ts (works with runtime env.js values)
const setAssetVariables = () => {
  const root = document.documentElement;
  const storageBaseUrl = env.storageBaseUrl || 'https://storage.googleapis.com/az-pc-dob-prod-static';

  root.style.setProperty('--assets-bucket', `'${storageBaseUrl}'`);
  root.style.setProperty('--img-area-marketing', `url(${storageBaseUrl}/assets/area-marketing.webp)`);
  root.style.setProperty('--img-logo-azimut', `url(${storageBaseUrl}/assets/logo-azimut-full.png)`);
};

// Set variables after env.js has time to load
setTimeout(setAssetVariables, 1000);

// Redirect logic for HashRouter to handle non-hash URLs (e.g., /front -> /#/login)
const handleHashRedirect = () => {
  const { pathname } = window.location;

  // Only valid path is root /
  // Any other subpath after .it is cleared
  if (pathname !== '/') {
    // Safely redirect to root with hash routing (no search params to prevent open redirection)
    window.location.replace('/#/');
  }
};

handleHashRedirect();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  //<React.StrictMode>
  <IntlProvider defaultLocale='it' locale='it'>
    {/* @ts-ignore */}
    <Provider store={store}>
      <HashRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}>
        <App />
      </HashRouter>
    </Provider>
  </IntlProvider>
  //</React.StrictMode>
);
